import React from 'react'

const BSPReports = () => {
  return (
    <div>
      BSPReports
      BSPReports
    </div>
  )
}

export default BSPReports
